/**
 * Navigation Component Styled Components
 *
 * @since 1.0.0
 */

import styled from '@emotion/styled';
import { colors } from '@redfoxwp/core-components/colors';
import { Link } from 'wouter';

export const NavigationMenu = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const NavigationItem = styled(Link, {
  shouldForwardProp: (prop: string) => prop !== '$isActive',
})<{ $isActive?: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 15px 30px;
  color: ${colors.gray[800]};
  text-decoration: none;
  font-size: 1.2em;
  font-weight: 400;
  transition: all 0.2s ease;
  border-top: 1px solid ${colors.gray[100]};
  position: relative;
  box-shadow: none !important;

  &:hover {
    color: ${colors.primary[300]};
  }

  &:focus,
  &:active {
    color: ${colors.primary[300]};
    box-shadow: 4px 0 0 0 ${colors.primary[300]} inset !important;
    background-color: ${colors.primary[50]};
  }

  ${(props: { $isActive?: boolean }) =>
    props.$isActive &&
    `
    color: ${colors.primary[300]};
    box-shadow: 4px 0 0 0 ${colors.primary[300]} inset !important;
    background-color: ${colors.primary[50]};
  `}
`;

export const NavigationItemIcon = styled.span`
  font-size: 1.2em;
  line-height: 1;
  flex-shrink: 0;
`;

export const NavigationItemLabel = styled.span`
  flex: 1;
`;
